import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'

import { fetchCategories } from 'ducks/categories'
import { fetchBestSellers } from 'ducks/bestSellers'

import { withCookieNotice } from '@/store/context/cookie-notice-context'

import { cookieCategoryIsActive } from '@/modern/utils/cookies'

import Main from 'components/Main'
import Page from '@/modern/components/Page'
import BestSeller from 'components/BestSeller'
import StatusHeader from 'components/Header/status'
import HomeProducts from 'container/Home/HomeProducts'
import PlaceHolder from 'components/PlaceHolder'
import RecommendedVehicles from 'components/RecommendedVehicles'

import { config } from 'config/config'
import { productsConfig } from 'config/config.products'
import {
  getCookie,
  cleanString,
  getCookieLocationLeft,
  getCookieLocationRight,
  onClientSide,
} from 'utils/utils'
import {
  COOKIES,
  VEHICLE_TYPE,
  ORIGIN_PAGES,
  COOKIE_NOTICE_TYPES,
} from 'utils/constants'
import { withTracking } from '@/modern/tracking/global/hooks/useTracking'
import createTrackingData from '@/modern/tracking/global/helpers/createTrackingData'
import { DATALAYER_PAGES } from '@/modern/tracking/pages'
import { getQueryParameter } from '@/utils/utils'
import Categories from '../Home/components/Categories'

class AdDisabled extends Component {
  constructor(props) {
    super(props)

    const { cookieNoticeContext, dispatchAnalyticsEvent } = this.props
    const { cookies } = cookieNoticeContext

    this.dispatchAnalyticsEvent = dispatchAnalyticsEvent

    this.cookiesState = {
      formData: cookieCategoryIsActive(cookies, COOKIES.FORM_DATA),
      sentLeads: cookieCategoryIsActive(cookies, COOKIES.SENT_LEADS),
    }

    this.state = {
      dataReady: 0,
      title: 'Anuncio Desativado',
      description: 'Anuncio Desativado',
      recommendationTimestamp: new Date()
        .toISOString()
        .replace(/T/, ' ')
        .replace(/Z/, ''),
    }
  }

  componentDidMount() {
    if (onClientSide()){
      window.scrollTo(0, 0)
    } 

    if (!this.props.categories.fetched){
      this.props
        .dispatch(fetchCategories())
        .then(() => this.setState({ dataReady: this.state.dataReady + 1 }))
    }
    else this.setState({ dataReady: this.state.dataReady + 1 })

    if (!this.props.bestSellers.fetched){
      this.props
        .dispatch(fetchBestSellers('br'))
        .then(() => this.setState({ dataReady: this.state.dataReady + 1 }))
    }
    else this.setState({ dataReady: this.state.dataReady + 1 })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.dataReady === 1 && this.state.dataReady === 2) {
      this.addDataLayer()
    }
    const oldCookies = prevProps.cookieNoticeContext.cookies
    const { cookies } = this.props.cookieNoticeContext

    if (
      JSON.stringify(oldCookies[COOKIE_NOTICE_TYPES.PROPOSALS]) !==
      JSON.stringify(cookies[COOKIE_NOTICE_TYPES.PROPOSALS])
    ) {
      this.cookiesState = {
        ...this.cookiesState,
        formData: cookieCategoryIsActive(cookies, COOKIES.FORM_DATA),
        sentLeads: cookieCategoryIsActive(cookies, COOKIES.SENT_LEADS),
      }
    }
  }


  addDataLayer() {
    if (onClientSide()) {
      const dataLayerBestSeller = []
      const dataLayerCategories = []
      const dataLayerProductsConfig = []
      const leadsIdsArr =
        this.cookiesState.sentLeads && getCookie(COOKIES.SENT_LEADS)

      if (this.props.bestSellers && this.props.bestSellers.fetched) {
        this.props.bestSellers.result.map((value, key) => {
          dataLayerBestSeller.push(
            `${key}:${value.make} ${value.model}${
              value.anode ? ` ${value.anode}` : ''
            }`
          )
        })
      }

      if (
        this.props.categories &&
        this.props.categories.fetched &&
        this.props.categories.result
      ) {
        this.props.categories.result.map((value, key) => {
          dataLayerCategories.push(`${key}:${value.Nome}`)
        })
      }

      if (
        this.props.recommendedVehicles &&
        this.props.recommendedVehicles.fetched
      ) {
        let array = this.props.recommendedVehicles.result.SearchResults.slice()
        if (leadsIdsArr) {
          array = array.filter(
            item => !leadsIdsArr.split(',').includes(`${item.UniqueId}`)
          )
        }
      }

      if (productsConfig) {
        productsConfig.map((value, key) => {
          dataLayerProductsConfig.push(`${key}:${value.Nome}`)
        })
      }

      const { search, href } = window.location
      const { userIsAuth } = this.props
      const customObjDatalayer = {
        site: {
          brandOrigin: getQueryParameter(search, 'origem') || 'webmotors',
        },
        page: {
          url: href,
          trackingCode: {
            idcmp: getQueryParameter(search, 'idcmp'),
            idcmpint: getQueryParameter(search, 'idcmpint'),
            icid: getQueryParameter(search, 'icid'),
            lkid: getQueryParameter(search, 'lkid'),
          },
          recommendationTimestamp: this.state.recommendationTimestamp,
        },
        user: {
          loginStatus: userIsAuth ? 1 : 2,
        },
      }

      const trackingData = createTrackingData(
        'customPageView',
        DATALAYER_PAGES.adDeactivatedSold,
        customObjDatalayer
      )

      this.dispatchAnalyticsEvent(trackingData)
    }
  }

  renderHelmet() {
    const _arr = this.props.location.pathname.split('/')
    let _title = ''
    let _description = ''
    if (_arr.length > 3) {
      const _make = _arr[2]
        ? cleanString(_arr[2], { toLowerCase: 1, capitalizeAll: 1 })
        : ''
      const _model = _arr[3]
        ? cleanString(_arr[3], { toLowerCase: 1, capitalizeAll: 1 })
        : ''
      const _vehicle =
        this.props.vehicleType == VEHICLE_TYPE.car
          ? cleanString(VEHICLE_TYPE.CAR, { toLowerCase: 1, capitalizeAll: 1 })
          : VEHICLE_TYPE.BIKE
      const _text =
        this.props.vehicleType == VEHICLE_TYPE.car
          ? 'novos e usados '
          : 'novas e usadas'

      _title = `${_vehicle} ${_make} ${_model} ${_text} na ${config.system}`
      _description = `Procurando ${_vehicle} ${_make} ${_model} ${_text}? Entre e confira as facilidadespara comprar na ${config.system}`
    }
    return (
      <Fragment>
        <Helmet>
          {_title ? <title>{_title}</title> : ''}
          <meta name="language" content="pt-br" />
          <meta name="robots" content="noindex, nofollow" />
          {_description ? (
            <meta name="description" content={_description} />
          ) : (
            ''
          )}
          <meta property="og:url" content={this.props.location.url} />
        </Helmet>
      </Fragment>
    )
  }

  render() {
    const _locationLeft = getCookieLocationLeft()
    const _locationRight = getCookieLocationRight()

    return (
      <Page headerBackLinkTo url={this.props.location} openFooter>
        {this.renderHelmet()}
        <Main className="page--notFound">
          <StatusHeader
            title="Veeeennndeeeeuuu,"
            subtitle="este anúncio já foi vendido ou desativado."
            contentText="Não fique triste, separamos algumas recomendações para você:"
          />

          <Categories
            id="categories-carousel"
            origin={ORIGIN_PAGES.DISABLED.KEY}
          />

          <RecommendedVehicles
            title={
              this.props.recommendedVehicles &&
              this.props.recommendedVehicles.fetched &&
              this.props.recommendedVehicles.result ? (
                'Recomendados para você'
              ) : (
                <PlaceHolder width="px" px="100" />
              )
            }
            vehicleType={this.props.vehicleType}
            origin={ORIGIN_PAGES.DISABLED.KEY}
            recommendationTimestamp={this.state.recommendationTimestamp}
          />
          <BestSeller
            source={
              this.props.bestSellers && this.props.bestSellers.fetched
                ? this.props.bestSellers.result
                : []
            }
            locationLeft={_locationLeft}
            locationRight={_locationRight}
            title={
              this.props.bestSellers.fetched &&
              this.props.bestSellers.result ? (
                'Carros mais buscados'
              ) : (
                <PlaceHolder width="px" px="100" />
              )
            }
            id="CarouselMostWanted"
          />
          <HomeProducts
            source={productsConfig || []}
            title={
              productsConfig.length ? (
                'Na Webmotors'
              ) : (
                <PlaceHolder width="px" px="100" />
              )
            }
            id="CarouselProductsWeb"
          />
        </Main>
      </Page>
    )
  }
}

export default withCookieNotice(
  connect(store => {
    return {
      categories: store.categoriesState,
      bestSellers: store.bestSellersState,
      recommendedVehicles: store.recommendedVehiclesState,
      userIsAuth: store.userIsAuth,
    }
  })(withTracking(AdDisabled))
)
